'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _NavigationState = require('../NavigationState');

var _NavigationState2 = _interopRequireDefault(_NavigationState);

var _Navigator = require('../Navigator');

var _Navigator2 = _interopRequireDefault(_Navigator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak
var StateCommandMap = function () {
    function StateCommandMap(navigator, injector) {
        (0, _classCallCheck3.default)(this, StateCommandMap);
        this.navigatorBehaviors = ['IHasStateValidationOptional', 'IHasStateUpdate'];

        this._navigator = navigator;
        this._injector = injector;
        this._commandsByState = {};
        this._verifiedCommandClasses = {};
    }

    (0, _createClass3.default)(StateCommandMap, [{
        key: 'mapCommand',
        value: function mapCommand(stateOrPath, CommandClass, aExactMatch, aOneShot) {
            var exactMatch = aExactMatch === undefined ? false : aExactMatch;
            var oneShot = aOneShot === undefined ? false : aOneShot;
            var state = _NavigationState2.default.make(stateOrPath);
            var commands = this._commandsByState[state.getPath()] || [];

            this._commandsByState[state.getPath()] = commands;
            this._navigator.add(this, state);

            if (this._hasCommand(commands, CommandClass)) {
                throw new Error('Already mapped ' + CommandClass + ' to state ' + state.getPath());
            }

            this._verifyCommandClass(CommandClass);

            commands.push({ CommandClass: CommandClass, state: state, exactMatch: exactMatch, oneShot: oneShot });
        }
    }, {
        key: 'unmapCommand',
        value: function unmapCommand(stateOrPath, CommandClass) {
            var state = _NavigationState2.default.make(stateOrPath);
            var commands = this._commandsByState[state.getPath()] || [];
            var i = void 0;
            var wrapper = void 0;
            this._commandsByState[state.getPath()] = commands;
            this._navigator.remove(this, state);
            for (i = commands.length; --i >= 0;) {
                wrapper = commands[i];
                if (wrapper.CommandClass === CommandClass) {
                    commands.splice(i, 1);
                    return;
                }
            }
        }
    }, {
        key: 'willValidate',
        value: function willValidate(truncatedState, fullState) {
            // will only validate if the state matches a command.
            return this.validate(truncatedState, fullState);
        }
    }, {
        key: 'validate',
        value: function validate(truncatedState, fullState) {
            var path = void 0;
            var mappedState = void 0;
            var commands = void 0;
            var isExact = void 0;
            var i = void 0;
            var wrapper = void 0;

            for (path in this._commandsByState) {
                mappedState = _NavigationState2.default.make(path);

                if (fullState.contains(mappedState)) {
                    commands = this._commandsByState[path];
                    isExact = fullState.equals(mappedState);

                    // reverse loop to accomodate for oneshot removal
                    i = commands.length;
                    for (i; --i >= 0;) {
                        wrapper = commands[i];
                        if (!isExact && wrapper.exactMatch) {
                            continue; // eslint-disable-line no-continue
                        }
                        return true;
                    }
                }
            }

            return false;
        }
    }, {
        key: 'updateState',
        value: function updateState(truncatedState, fullState) {
            var path = void 0;
            var mappedState = void 0;
            var commands = void 0;
            var isExact = void 0;
            var i = void 0;
            var wrapper = void 0;
            var command = void 0;

            for (path in this._commandsByState) {
                mappedState = _NavigationState2.default.make(path);
                if (fullState.contains(mappedState)) {
                    commands = this._commandsByState[path];
                    isExact = fullState.equals(mappedState);

                    // reverse loop to accomodate for oneshot removal
                    i = commands.length;
                    for (i; --i >= 0;) {
                        wrapper = commands[i];
                        if (!isExact && wrapper.exactMatch) {
                            continue; // eslint-disable-line no-continue
                        }

                        this._injector.map('fullState').toValue(fullState);
                        this._injector.map('truncatedState').toValue(fullState.subtract(wrapper.state));

                        command = new wrapper.CommandClass({ injector: this._injector });
                        command.execute();

                        this._injector.unmap('fullState');
                        this._injector.unmap('truncatedState');

                        if (wrapper.oneShot) {
                            this.unmapCommand(wrapper.state, wrapper.CommandClass);
                        }
                    }
                }
            }
        }
    }, {
        key: '_hasCommand',
        value: function _hasCommand(wrappedCommandsList, testForCommandClass) {
            var i = void 0;
            var commandWrapper = void 0;
            var length = wrappedCommandsList.length;
            for (i = 0; i < length; i++) {
                commandWrapper = wrappedCommandsList[i];
                if (commandWrapper.CommandClass === testForCommandClass) {
                    return true;
                }
            }
            return false;
        }
    }, {
        key: '_verifyCommandClass',
        value: function _verifyCommandClass(CommandClass) {
            if (this._verifiedCommandClasses[CommandClass]) {
                return;
            }
            if (CommandClass.prototype.execute === undefined) {
                throw new Error('Command doesn\'t implement an execute method - ' + CommandClass);
            }
            this._verifiedCommandClasses[CommandClass] = true;
        }
    }]);
    return StateCommandMap;
}();

exports.default = StateCommandMap;
//# sourceMappingURL=StateCommandMap.js.map